<template>
  <div id="div-with-loading" class="vs-con-loading__container">
    <div class="vx-row">
      <vx-card class="centered-page-container">
        <div class="approve-rebate-amount">
          <div class="indented-section">
            <!-- Title & Status -->
            <div class="vx-row flex-wrap justify-between title-bar px-4">
              <h2>{{ heading }}</h2>

              <div class="flex-wrap client-specific">
                <!-- TODO: Get status -->
                <vs-chip transparent color="dark" class="custom-bg">
                  Current Status: <strong class="px-2"> {{ displayRebateStatus }} </strong>
                </vs-chip>
              </div>
            </div>

            <hr>

            <!-- Row 1 Data -->
            <div class="vx-row flex-wrap mt-8 px-5">
              <div class="vx-col w-1/4"><strong>Partner Name</strong></div>
              <div class="vx-col w-1/4"><strong>Period</strong></div>
              <div class="vx-col w-1/4"><strong>Payment Mode</strong></div>
              <div class="vx-col w-1/4"><strong>Account Manager</strong></div>
            </div>

            <div class="vx-row flex-wrap px-5">
              <div class="vx-col w-1/4">{{ this.toTitleCase(summary['partner_name']) }}</div>
              <div class="vx-col w-1/4 break-words">{{ summary['period'] ? summary['period'].join(',') : summary['period'] }}</div>
              <div class="vx-col w-1/4">{{ this.toTitleCase(summary['payment_mode']) }}</div>
              <div class="vx-col w-1/4">{{ this.toTitleCase(summary['am']) }}</div>
            </div>

            <br />

            <!-- Row 2 Data -->
            <div class="vx-row flex-wrap px-5">
              <div class="vx-col w-1/4"><strong>Domain Count</strong></div>
              <div class="vx-col w-1/4"><strong>Rebate Amount</strong></div>
            </div>

            <div class="vx-row flex-wrap px-5">
              <div class="vx-col w-1/4">{{ summary['domain_count'] }}</div>
              <div class="vx-col w-1/4" v-if="parseFloat(summary['sum_of_rebates']) < 0">-${{ Number(Math.abs(parseFloat(summary['sum_of_rebates'])).toFixed(2)).toLocaleString('en', { minimumFractionDigits: 2 })  }}</div>
              <div class="vx-col w-1/4" v-else>${{ Number(parseFloat(summary['sum_of_rebates']).toFixed(2)).toLocaleString('en', { minimumFractionDigits: 2 })  }}</div>
            </div>

            <br />

            <hr />
            
            <!-- Calculation & Invoice -->
            <div class="vx-row flex-wrap justify-start px-10 mt-6">
              <div class="vx-col w-2/3 mb-2 form-field">
                <!-- Calculation Sheet download & actions -->
                <div class="vx-row w-full">
                  <div class="vx-col w-full pl-0 pr-0">
                    <label class="vs-input--label inline-flex pb-2">{{ labels['calculationSheetLabel'] }}</label>
                    <div class="upload-input relative cursor-pointer" @click="downloadFile(summary['file_url'])">
                      <vs-button
                        class="upload-btn flex align-center"
                        style="text-overflow: ellipsis"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-file-text">
                        {{ summary['file_name'] }}
                      </vs-button>
                      <span
                        style="
                          position: absolute;
                          right: 0;
                          bottom: 0;
                          transform: translate(-80%, -10%);">
                        <feather-icon
                          icon="DownloadIcon"
                          color="primary"
                          class="primary"
                          style="width: 18px; height: 18px; color: #000000"/>
                      </span>
                    </div>

                    <div class="upload-input relative mt-2" v-if="summary['error_file_url']" @click="downloadFile(summary['error_file_url'])">
                      <vs-button
                        v-if="summary['error_file_url']"
                        class="upload-btn flex align-center"
                        style="text-overflow: ellipsis"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-file-text">
                        {{
                          summary['error_file_name']
                        }}
                      </vs-button>
                      <span style="
                          position: absolute;
                          right: 0;
                          bottom: 0;
                          transform: translate(-80%, -10%);">
                        <feather-icon
                          icon="DownloadIcon"
                          color="primary"
                          class="primary"
                          style="width: 15px; height: 15px; color: #000000"/>
                      </span>
                    </div>
                  </div>
                </div>
                
                <!-- Invoice & Credit Note upload & download -->
                <div class="vx-row w-full">
                  <div class="vx-col pl-0" v-if="labels['clientInvoiceLabel']" :class="labels['creditNoteLabel'] ? 'w-1/2' : 'w-full pr-0'">
                    <label class="vs-input--label inline-flex pb-2 mt-4">{{ labels['clientInvoiceLabel'] }}</label>
                    <div class="upload-input relative">
                      <input
                        v-if="summary['status'] === statusConstants['Approved by Partner'] || summary['status'] === statusConstants['Invoice Rejected']"
                        name="invoiceFile"
                        type="file"
                        :id="`invoiceFile`"
                        :ref="`invoiceFile`"
                        class="absolute top-0 left-0 w-full h-full z-10 opacity-0 cursor-pointer"
                        @change="handleFileChange($event, 'invoiceFormData')"/>
                      <vs-button
                        class="upload-btn flex align-center"
                        style="text-overflow: ellipsis"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-file-text"
                        @click="downloadFile(invoiceData['invoice_file_url'])">
                        {{
                          summary['status'] === statusConstants["Invoice Received"] || summary['status'] === statusConstants["Invoice Approved"]  ? truncate(invoiceData["invoice_file_name"], 20) : "Drag & Drop PDF Here"
                        }}
                      </vs-button>
                      <span
                        v-if="summary['status'] === statusConstants['Invoice Received'] || summary['status'] === statusConstants['Invoice Approved']"
                        style="
                          position: absolute;
                          right: 0;
                          bottom: 0;
                          transform: translate(-80%, -10%);">
                        <feather-icon
                          icon="DownloadIcon"
                          color="primary"
                          class="primary cursor-pointer"
                          style="width: 18px; height: 18px; color: #000000"
                          @click="downloadFile(invoiceData['invoice_file_url'])"/>
                      </span>
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('invoiceFile')">
                        Required field
                      </span>
                      <div class="file-errors-wrap flex flex-wrap">
                        <ul v-show="formData['invoiceFormData']['fileName']" class="pt-2 pr-5">
                          <li class="flex items-center">
                            <p class="pr-1"
                              :class="
                                formData['invoiceFormData']['fileTypeError'] || formData['invoiceFormData']['fileSizeError']
                                  ? 'color-gray'
                                  : 'text-primary'">
                              {{ formData['invoiceFormData']["fileName"] }}
                            </p>
                            <!-- Hide remove icon if filesize or filetype error is there. -->
                            <vs-button
                              v-show="!formData['invoiceFormData']['fileTypeError'] && !formData['invoiceFormData']['fileSizeError']"
                              color="danger"
                              type="flat"
                              icon-pack="feather"
                              icon="icon-x"
                              class="remove-agt-file-btn"
                              @click="removeFile('invoiceFile', formData['invoiceFormData'])">
                            </vs-button>
                          </li>
                        </ul>
                        <p v-show="formData['invoiceFormData']['fileTypeError']" class="pt-2 text-danger">
                          {{ formData['invoiceFormData']["fileTypeError"] }}
                        </p>
                        <p v-show="formData['invoiceFormData']['fileSizeError']" class="pt-2 text-danger">
                          {{ formData['invoiceFormData']["fileSizeError"] }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="vx-col w-1/2 pr-0" v-if="(labels['creditNoteLabel'] == 'Upload Credit Note') || (labels['creditNoteLabel'] == 'Download Credit Note' && invoiceData['creditNote_file_name'] !== '')">
                    <label class="vs-input--label inline-flex pb-2 mt-4">
                      {{
                        labels['creditNoteLabel']
                      }}
                    </label>
                    <div class="upload-input relative">
                      <input
                        v-if="summary['status'] === statusConstants['Approved by Partner'] || summary['status'] === statusConstants['Invoice Rejected']"
                        name="creditNoteFile"
                        type="file"
                        :id="`creditNoteFile`"
                        :ref="`creditNoteFile`"
                        class="absolute top-0 left-0 w-full h-full z-10 opacity-0 cursor-pointer"
                        @change="handleFileChange($event, 'creditNoteFormData')"/>
                      <vs-button
                        class="upload-btn flex align-center"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-file-text"
                        @click="downloadFile(invoiceData['creditNote_file_url'])">
                        {{
                          summary['status'] === statusConstants["Invoice Received"] || summary['status'] === statusConstants['Invoice Approved']
                            ? truncate(invoiceData['creditNote_file_name'], 20)
                            : "Drag & Drop PDF Here"
                        }}
                      </vs-button>
                      <span
                        v-if="summary['status'] === statusConstants['Invoice Received'] || summary['status'] === statusConstants['Invoice Approved']"
                        style="
                          position: absolute;
                          right: 0;
                          bottom: 0;
                          transform: translate(-80%, -10%);">
                        <feather-icon
                          icon="DownloadIcon"
                          color="primary"
                          class="primary cursor-pointer"
                          style="width: 18px; height: 18px; color: #000000" 
                          @click="downloadFile(invoiceData['creditNote_file_url'])"/>
                      </span>
                      <span class="text-danger text-sm" v-show="errors.has('creditNoteFile')">Required field</span>
                      <div class="file-errors-wrap flex flex-wrap">
                        <ul v-show="formData['creditNoteFormData']['fileName']" class="pt-2 pr-5">
                          <li class="flex items-center">
                            <p
                              class="pr-1 word-wrap"
                              :class="
                                formData['creditNoteFormData']['fileTypeError'] || formData['creditNoteFormData']['fileSizeError']
                                  ? 'color-gray'
                                  : 'text-primary'">
                              {{ formData['creditNoteFormData']["fileName"] }}
                            </p>
                            <!-- Hide remove icon if filesize or filetype error is there. -->
                            <vs-button
                              v-show="!formData['creditNoteFormData']['fileTypeError'] && !formData['creditNoteFormData']['fileSizeError']"
                              color="danger"
                              type="flat"
                              icon-pack="feather"
                              icon="icon-x"
                              class="remove-agt-file-btn"
                              @click="removeFile('creditNoteFile', formData['creditNoteFormData'])">
                            </vs-button>
                          </li>
                        </ul>
                        <p v-show="formData['creditNoteFormData']['fileTypeError']" class="pt-2 text-danger">
                          {{ formData['creditNoteFormData']["fileTypeError"] }}
                        </p>
                        <p v-show="formData['creditNoteFormData']['fileSizeError']" class="pt-2 text-danger">
                          {{ formData['creditNoteFormData']["fileSizeError"] }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="summary['payment_mode'] !== 'cnic'" class="vx-col w-1/3 mb-2">
                <!-- Calculation Sheet Actions  -->
                <label v-if="showCalculationActions" class="vs-input--label inline-flex pb-2">Rebate Calculation Actions:</label>
                <div
                  v-if="showCalculationActions"
                  class="flex flex-wrap"
                  style="justify-content: flex-start;">
                  <div style="margin-right: 1rem">
                    <vs-button
                      v-if="summary['status'] == statusConstants['Approved by Radix']"
                      icon-pack="feather"
                      icon="icon-check"
                      id="button-with-loading"
                      color="primary"
                      type="filled"
                      class="custom-btn accept-btn"
                      @click="approveRebateSummary()">
                      Accept
                    </vs-button>

                    <vs-button
                      v-else-if="flags['summaryAccepted']"
                      icon-pack="feather"
                      icon="icon-check"
                      id="button-with-loading"
                      color="primary"
                      type="filled"
                      class="custom-btn accepted-btn">
                      Accepted
                    </vs-button>
                  </div>
                  <div>
                    <vs-button
                      v-if="summary['status'] === statusConstants['Approved by Radix']"
                      icon-pack="feather"
                      icon="icon-x"
                      id="button-with-loading"
                      color="danger"
                      type="filled"
                      class="custom-btn reject-btn"
                      @click="rejectRebateSummary()">
                      Reject
                    </vs-button>

                    <vs-button
                      v-else-if="flags['summaryRejected']"
                      icon-pack="feather"
                      icon="icon-x"
                      id="button-with-loading"
                      color="danger"
                      type="filled"
                      class="custom-btn rejected-btn">
                      Rejected
                    </vs-button>
                  </div>
                </div>
                <!-- Calculation Sheet Actions  -->

                <!-- Invoice Actions -->
                <label v-if="showInvoiceActions" class="vs-input--label inline-flex pb-2 mt-5">Client Invoice Actions:</label>
                <div v-if="showInvoiceActions" class="flex flex-wrap" style="justify-content: flex-start;">
                  <div style="margin-right: 1rem">
                    <vs-button
                      v-if="summary['status'] === statusConstants['Approved by Partner'] || summary['status'] === statusConstants['Invoice Rejected']"
                      icon-pack="feather"
                      icon="icon-upload"
                      id="button-with-loading"
                      color="primary"
                      type="filled"
                      class="custom-btn accept-btn"
                      :disabled="isDisabledUpload"
                      @click="uploadInvoiceAndCreditNote()">
                      Upload Invoice & Credit Note
                    </vs-button>

                    <vs-button
                      v-else-if="flags['invoiceApprovalPending']"
                      icon-pack="feather"
                      icon="icon-clock"
                      id="button-with-loading"
                      color="primary"
                      type="filled"
                      class="custom-btn accepted-btn">
                      Pending Approval
                    </vs-button>

                    <vs-button
                      v-else-if="flags['invoiceAccepted']"
                      icon-pack="feather"
                      icon="icon-check"
                      id="button-with-loading"
                      color="primary"
                      type="filled"
                      class="custom-btn accepted-btn">
                      Accepted
                    </vs-button>
                    
                    <vs-button
                      v-else-if="flags['invoiceRejected']"
                      icon-pack="feather"
                      icon="icon-x"
                      id="button-with-loading"
                      color="danger"
                      type="filled"
                      class="custom-btn rejected-btn">
                      Rejected
                    </vs-button>
                  </div>
                </div>
                <!-- Invoice Actions -->
              </div>
            </div>

            <!-- <hr /> -->
          </div>
        </div>
      </vx-card>

      <vs-popup :active.sync="rejectRebateSummaryPopup" title="Provide Information" class="reject-rebate-summary-popup">
        <vx-card>
          <div class="vx-row flex-wrap px-5">
            <p>Please enter the reason for rejecting the rebate amount in the box below. This response will be saved internally for records.</p>
            
            <div class="mt-5 w-full">
              <div class="mx-auto upload-input relative">
                <vs-input v-model="rejectRebateSummaryReason" :name="`rejectRebateSummaryReason`" type="text" style="cursor: pointer" v-validate="'required'" class="absolute top-0 left-0 w-full h-full z-10 opacity-0" />
              </div>
            </div>
          </div>

          <div class="vx-row mt-6 mb-3">
            <vs-button class="mx-auto" type="filled" icon-pack="feather" @click="rejectRebateSummaryReason()" :disabled="!rejectRebateSummaryReason">Submit</vs-button>
          </div>
        </vx-card>
      </vs-popup>
      
      <!-- Rebates Summary component START -->
      <RebatesSummarySheet
        class="px-3 mx-auto w-3/4 mt-0"
        :source="'clientApproveSummary'"
        :sharedListData="rebatesSummaryData"
        :directListData="[]"
        :autoRenewListData="[]"
        :customListData="[]">
      </RebatesSummarySheet>
      <!-- Rebates Summary component END -->

      <custom-prompt
        :activePrompt.sync="customPrompt['activePrompt']"
        :title="customPrompt['title']"
        :buttonText="customPrompt['buttonText']"
        :acceptText="customPrompt['acceptText']">

        <div class="con-content" slot="content">
          
        </div>
      </custom-prompt>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import RebatesSummarySheet from "@/components/ag-grid-tables/rebates/rebates-summary/RebatesSummarySheet.vue";
import statusConstants from "@/json/statusConstants.json";

export default {
  name: "ApproveRebateAmount",
  components: {
    "v-select": vSelect,
    RebatesSummarySheet,
  },
  data() {
    return {
      heading: '',
      rebateListDetailsPopupActive: false,
      isDisabledUpload: true,
      argsData: {},
      statusConstants: statusConstants,
      formInit: {
        pending_months: [],
      },
      partner_name: "",
      type: "",
      summary: {
        status: '',
        new_reseller_id: '',
        partner_name: '',
        type: '',
        period: [],
        period_other: [],
        file_name: '',
        file_url: '',
        error_file_name: '',
        error_file_url: '',
        list_based: '',
        list_frequency: '',
        list_type: '',
        payment_mode: '',
        poc1_name: '',
        am: '',
        net_revenue: '',
        domain_count: '',
        sum_of_rebates: '',
        sum_of_revenue: '',
      },
      invoiceData: {
        invoice_file_name: '',
        invoice_file_url: '',
        creditNote_file_name: '',
        creditNote_file_url: ''
      },
      labels: {
        calculationSheetLabel: "",
        clientInvoiceLabel: "",
        creditNoteLabel: "",
      },
      rebatesSummaryData: [],
      showCalculationActions: false,
      showInvoiceActions: false,
      formData: {
        invoiceFormData: {
          fileTypeError: "",
          fileSizeError: "",
          fileName: "",
          filePath: "",
          fileExtension: "",
        },
        creditNoteFormData: {
          fileTypeError: "",
          fileSizeError: "",
          fileName: "",
          filePath: "",
          fileExtension: "",
        }
      },
      // Custom Dialog props
      customPrompt: {
        activePrompt: false,
        title: "",
        buttonText: "",
        acceptText: "",
      },
      flags: {
        summaryAccepted: false,
        summaryRejected: false,
        invoiceApprovalPending: false,
        invoiceAccepted: false,
        invoiceRejected: false
      },
      rejectRebateSummaryPopup: false,
      rejectRebateSummaryReason: null
    };
  },
  beforeMount() {
    // NOTE: Verify the token
    this.fetchData();
  },
  computed: {
    displayRebateStatus() {
      return Object.keys(statusConstants).find(key => statusConstants[key] == this.summary['status']);
    }
  },
  watch: {
    'summary.status'() {
      this.flags['summaryAccepted'] = [statusConstants['Approved by Radix'], statusConstants['Approved by Partner'], statusConstants['Invoice Received'], statusConstants['Invoice Approved']].some(x => x == this.summary['status']);
      this.flags['summaryRejected'] = [statusConstants['Rejected by Radix'], statusConstants['Rejected by Partner']].some(x => x == this.summary['status']);
      this.flags['invoiceApprovalPending'] = [statusConstants['Invoice Received']].some(x => x == this.summary['status']);
      this.flags['invoiceAccepted'] = [statusConstants['Invoice Approved']].some(x => x == this.summary['status']);
      this.flags['invoiceRejected'] = [statusConstants['Invoice Rejected']].some(x => x == this.summary['status']);
    },
    formData: {
      deep: true,
      handler() {
        if(this.formData['invoiceFormData']['fileName'] !== "") {
          this.isDisabledUpload = false;
        } else {
          this.isDisabledUpload = true;
        }
      }
    },
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
    },
    hideLoadingInDiv() {
        this.$vs.loading.close("#div-with-loading > .con-vs-loading");
    },
    fetchData() {
      this.$axiosSecureClient
      .get(`/summary/${localStorage.getItem('loggedInPartnerId')}/${localStorage.getItem('clientRebateStatus')}`)
      .then((response) => {
        this.id = response.data.data.id;
        this.summary['status'] = response.data.data.status;
        this.summary['new_reseller_id'] = response.data.data.new_reseller_id;
        this.summary['partner_name'] = response.data.data.rebates_summary_data[0].new_reseller_name;
        this.summary['type'] = response.data.data.rebates_summary_data[0].type;
        this.summary['period'] = response.data.data.rebates_summary_data[0].period;
        this.summary['period_other'] = response.data.data.rebates_summary_data[0].period_other;
        this.summary['file_name'] = response.data.data.rebates_summary_data[0].client_file_name;
        this.summary['file_url'] = response.data.data.rebates_summary_data[0].client_file_url;
        this.summary['error_file_name'] = response.data.data.rebates_summary_data[0].client_error_file_name;
        this.summary['error_file_url'] = response.data.data.rebates_summary_data[0].client_error_file_url;
        this.summary['list_based'] = response.data.data.rebates_summary_data[0].list_based;
        this.summary['list_frequency'] = response.data.data.rebates_summary_data[0].list_frequency;
        this.summary['list_type'] = response.data.data.rebates_summary_data[0].list_type;
        this.summary['payment_mode'] = response.data.data.rebates_summary_data[0].payment_mode;
        this.summary['poc1_name'] = response.data.data.rebates_summary_data[0].poc_details[0].name;
        this.summary['am'] = response.data.data.rebates_summary_data[0].am;
        this.summary['net_revenue'] = response.data.data.rebates_summary_data[0].net_revenue;
        this.summary['domain_count'] = response.data.data.rebates_summary_data[0].domain_count;
        this.summary['sum_of_rebates'] = response.data.data.rebates_summary_data[0].sum_of_rebates;
        this.summary['sum_of_revenue'] = response.data.data.rebates_summary_data[0].sum_radix_revenue;

        if(response.data.data.rebates_status && response.data.data.rebates_status[0]) {
          this.invoiceData['invoice_file_name'] = response.data.data.rebates_status[0].invoice_file_name;
          this.invoiceData['invoice_file_url'] = response.data.data.rebates_status[0].invoice_path ? process.env.VUE_APP_API + '/storage/' + response.data.data.rebates_status[0].invoice_path.split('public/')[1] : null;
          this.invoiceData['creditNote_file_name'] = response.data.data.rebates_status[0].credit_note_file_name ? response.data.data.rebates_status[0].credit_note_file_name : '';
          this.invoiceData['creditNote_file_url'] = response.data.data.rebates_status[0].credit_note_path ? process.env.VUE_APP_API + '/storage/' + response.data.data.rebates_status[0].credit_note_path.split('public/')[1] : null;
          this.invoiceData['pt_ticket_id'] = response.data.data.rebates_status[0].pt_ticket_id;
          this.invoiceData['pt_status'] = response.data.data.rebates_status[0].pt_status;

          if(this.invoiceData['invoice_file_name']) {
            this.labels['clientInvoiceLabel'] = 'Download Client Invoice';
          }

          if(this.invoiceData['creditNote_file_name']) {
            this.labels['creditNoteLabel'] = 'Download Credit Note';
          }
        }

        this.rebatesSummaryData = response.data.data.rebates_summary_detail;

        if(response.data.data.status) {
          localStorage.setItem('clientRebateStatus', response.data.data.status);
          this.$store.dispatch('setClientRebateStatus', localStorage.getItem('clientRebateStatus'));
        }

        this.filterBasedOnStatus();

        if (this.gridApi) {
          setTimeout(() => {
            // this.initSelectedAllFlag();
          }, 1000);
        }
      })
      .catch((error) => {
        this.$store.dispatch('clearListingCount');
      });
    },
    handleFileChange(event, fileUploadFor) {
      this.formData[fileUploadFor]["fileTypeError"] = "";
      this.formData[fileUploadFor]["fileSizeError"] = "";
      this.formData[fileUploadFor]["fileExtension"] = "";

      this.formData[fileUploadFor]["fileName"] = event.target.files[0].name;
      this.formData[fileUploadFor]["fileExtension"] = this.formData[fileUploadFor]["fileName"].split(".").pop();

      // Check File Type
      this.formData[fileUploadFor]["filePath"] = event.target.value;

      // Allowed file types
      var allowedExtensions = /(\.pdf|\.csv||\.doc|\.docx|\.jpg|\.jpeg|\.png)$/i;

      if (!allowedExtensions.exec(this.formData[fileUploadFor]["filePath"])) {
        this.formData[fileUploadFor]["fileTypeError"] = "Invalid file (Please upload a PDF, CSV, DOC, JPG or PNG file under 25mb)";
        return false;
      }

      //Check File Size
      var ogFileSize = event.target.files[0].size;
      var fileSize = Math.round(ogFileSize / 1024);

      if (fileSize >= 25600) {
        fileUploadFor["fileSizeError"] =
          "Please select a file under 25mb";
      }
    },
    removeFile(fileToRemove, typeOfFile) {
      (this.$refs[fileToRemove].value = null),
        (this[typeOfFile]['fileName'] = ''),
        (this[typeOfFile]['fileTypeError'] = ''),
        (this[typeOfFile]['fileSizeError'] = ''),
        (this[typeOfFile]['fileExtension'] = '');
    },
    uploadInvoiceAndCreditNote() {
      this.openLoadingInDiv();

      let payload = new FormData();

      payload.append('new_reseller_id', this.summary['new_reseller_id']);
      payload.append('invoice_file_name', this.$refs.invoiceFile.files[0]);
      if(this.$refs.creditNoteFile && this.$refs.creditNoteFile.files[0]) {
        payload.append('credit_note_file_name', this.$refs.creditNoteFile.files[0]);
      } else {
        payload.append('credit_note_file_name', null);
      }

      this.$axiosSecureClient.post('/invoice/upload', payload)
      .then(response => {
        this.summary['status'] = response.data.data;

        if(response.data.data) {
          localStorage.setItem('clientRebateStatus', response.data.data);
          this.$store.dispatch('setClientRebateStatus', localStorage.getItem('clientRebateStatus'));
        }

        this.filterBasedOnStatus();
        this.fetchData();
        this.formData = {
          invoiceFormData: {
            fileTypeError: "",
            fileSizeError: "",
            fileName: "",
            filePath: "",
            fileExtension: "",
          },
          creditNoteFormData: {
            fileTypeError: "",
            fileSizeError: "",
            fileName: "",
            filePath: "",
            fileExtension: "",
          }
        }
        this.hideLoadingInDiv();
      })
      .catch(error => {
        this.handleActionError(error);
      })

    },
    // The API refused the action because this rebate already moved on, or something else broke
    handleActionError(error) {
      let response = error.response;
      let message = response && response.data ? response.data.message : null;
      let conflict = response && response.data && response.data.conflicts ? response.data.conflicts[0] : null;

      this.hideLoadingInDiv();

      if (response && response.status === 409) {
        // Adopt the status the server reports before re-reading, otherwise the next
        // request asks for a cycle in a status this partner is no longer in
        if (conflict && conflict.current_status) {
          localStorage.setItem('clientRebateStatus', conflict.current_status);
          this.$store.dispatch('setClientRebateStatus', conflict.current_status);
          this.summary['status'] = conflict.current_status;
          this.filterBasedOnStatus();
        }

        this.$vs.notify({
          color: 'warning',
          title: 'Status already changed',
          text: message || 'This rebate has already moved on.',
          time: 6000,
        });

        this.fetchData();
        return;
      }

      this.$vs.notify({
        color: 'danger',
        title: 'Something went wrong',
        text: message || 'Please contact the server admin',
      });

      console.log(error);
    },
    filterBasedOnStatus() {
      switch (this.summary['status']) {
        case statusConstants["Approved by Radix"]: {
          this.heading = 'Approve Rebates Amount';
          this.labels['calculationSheetLabel'] = "Download Rebate Calculation Sheet";
          this.showCalculationActions = true;
          break;
        }

        case statusConstants["Rejected by Radix"]: {
          this.heading = 'Calculations Review Pending';
          this.labels['calculationSheetLabel'] = "Download Rebate Calculation Sheet";
          this.showCalculationActions = true;
          break;
        }

        case statusConstants["Approved by Partner"]: {
          this.heading = 'Upload Invoice';
          this.labels['calculationSheetLabel'] = "Download Rebate Calculation Sheet";
          this.labels['clientInvoiceLabel'] = "Upload Client Invoice";
          this.labels['creditNoteLabel'] = "Upload Credit Note";
          this.showCalculationActions = true;
          this.showInvoiceActions = true;
          break;
        }

        case statusConstants["Rejected by Partner"]: {
          this.heading = 'Calculations Review Pending';
          this.labels['calculationSheetLabel'] = "Download Rebate Calculation Sheet";
          this.showCalculationActions = true;
          break;
        }

        case statusConstants["Invoice Received"]: {
          this.heading = 'Invoice pending for approval';
          this.labels['calculationSheetLabel'] = "Download Rebate Calculation Sheet";
          this.labels['clientInvoiceLabel'] = "Download Invoice";
          if(this.invoiceData['creditNote_file_name'] !== '') {
            this.labels['creditNoteLabel'] = "Download Credit Note";
          } else{
            this.labels['creditNoteLabel'] = null;
          }
          this.showCalculationActions = true;
          this.showInvoiceActions = true;
          break;
        }
        
        case statusConstants["Invoice Approved"]: {
          this.heading = 'Payment under process';
          this.labels['calculationSheetLabel'] = "Download Rebate Calculation Sheet";
          this.labels['clientInvoiceLabel'] = "Download Invoice";
          this.labels['creditNoteLabel'] = "Download Credit Note";
          this.showCalculationActions = true;
          this.showInvoiceActions = true;
          break;
        }

        case statusConstants["Invoice Rejected"]: {
          this.heading = 'Upload Updated Invoice';
          this.labels['calculationSheetLabel'] = "Download Rebate Calculation Sheet";
          this.labels['clientInvoiceLabel'] = "Upload Invoice";
          this.labels['creditNoteLabel'] = "Upload Credit Note";
          this.showCalculationActions = true;
          this.showInvoiceActions = true;
          break;
        }
      }
    },
    // NOTE: What happens when Rebate Summary is accepted
    approveRebateSummary() {
      this.openLoadingInDiv();

      let payload = {
        new_reseller_id: this.summary['new_reseller_id'],
        // TODO: Add summary ID in payload
        // id: this.id
      }

      this.$axiosSecureClient
        .post(`/summary/approve`, payload)
        .then((response) => {
          // NOTE: Update status & change view of screen
          this.summary['status'] = response.data.data;

          if(response.data.data) {
            localStorage.setItem('clientRebateStatus', response.data.data);
            this.$store.dispatch('setClientRebateStatus', localStorage.getItem('clientRebateStatus'));
          }

          this.filterBasedOnStatus();
          this.hideLoadingInDiv();
        })
        .catch((error) => {
          this.handleActionError(error);
        })
    },
    // NOTE: What happens when Rebate Summary is rejected
    rejectRebateSummary() {
      this.openLoadingInDiv();

      this.rejectRebateSummaryPopup = true;

      let payload = {
        new_reseller_id: this.summary['new_reseller_id'],
        filename: this.summary['file_name'],
        list_frequency: this.summary['list_frequency'],
        period: this.summary['period'][0],
        reason: this.rejectRebateSummaryReason
        // TODO: Add summary ID in payload
        // id: this.id
      }
        
      this.$axiosSecureClient
        .post(`/summary/reject`, payload)
        .then((response) => {
          // NOTE: Update status & change view of screen
          this.summary['status'] = response.data.data;

          if(response.data.data) {
            localStorage.setItem('clientRebateStatus', response.data.data);
            this.$store.dispatch('setClientRebateStatus', localStorage.getItem('clientRebateStatus'));
          }

          this.filterBasedOnStatus();
          this.hideLoadingInDiv();
        })
        .catch((error) => {
          this.handleActionError(error);
        })
    },
    // NOTE: Generic function to download calculation sheet, invoice, credit note etc.
    downloadFile(url) {
      window.open(url, '_blank');
    }
  },
  destroyed() {},
};
</script>

<style></style>
